<svg
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	width="100%"
	height="100%"
	viewBox="0 0 24 24"
	version="1.1"
>
	<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		<path
			d="M11.95,1.79999996 C12.95,1.79999996 13.95,2.29999996 14.55,3.29999996 L14.55,3.29999996 L23.05,18 C24.2500001,20 22.8,22.5 20.5,22.5 L20.5,22.5 L3.54999996,22.5 C1.24999996,22.5 -0.200000051,20 0.949999954,18 L0.949999954,18 L9.34999999,3.29999996 C9.94999999,2.29999996 10.95,1.79999996 11.95,1.79999996 Z M12.0551407,3.30084441 L11.9448593,3.30084441 C11.6644444,3.30955552 11.0733333,3.39666663 10.7,4.04999997 L10.7,4.04999997 L2.19999996,18.75 C1.79999996,19.45 2.04999996,20 2.19999996,20.25 C2.34999996,20.5 2.69999996,21 3.49999996,21 L3.49999996,21 L20.5,21 C21.25,21 21.65,20.5 21.75,20.25 C21.9,20 22.15,19.45 21.8,18.75 L21.8,18.75 L13.3,4.04999997 C12.9,3.34999996 12.25,3.29999996 12,3.29999996 Z M12,16.5 C12.6903559,16.5 13.25,17.0596441 13.25,17.75 C13.25,18.440356 12.6903559,19 12,19 C11.3096441,19 10.75,18.440356 10.75,17.75 C10.75,17.0596441 11.3096441,16.5 12,16.5 Z M13,8.49999999 L13,15 L11,15 L11,8.49999999 L13,8.49999999 Z"
			fill="currentColor"
		></path>
	</g>
</svg>
